import {
  getForegroundPermissionsAsync,
  hasServicesEnabledAsync,
} from 'expo-location';
import { logEvent } from 'services/analytics/segment/segment';
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

export const trackGeolocationStatus = async (): Promise<void> => {
  try {
    const { status } = await getForegroundPermissionsAsync();
    const servicesEnabled = await hasServicesEnabledAsync();

    await logEvent('Geolocation Permission Checked', {
      category: 'login',
      source_name: 'post_login_sync',
      permission_status: status,
      is_services_enabled: servicesEnabled,
    });
  } catch (error) {
    logBreadcrumb({
      level: 'error',
      message: `Error while getting GeolocationStatus: ${error}`,
    });
  }
};
